import { SET_VIEWING_SCP_FORM } from "../../constants";

export interface SetViewingSCPFormAction {
    data: {
        isViewingSoftCreditRatingForm: boolean;
    };
    type: SET_VIEWING_SCP_FORM;
}

export function setIsViewingSCPForm(isViewingSoftCreditRatingForm: boolean): SetViewingSCPFormAction {
    return {
        data: { isViewingSoftCreditRatingForm },
        type: SET_VIEWING_SCP_FORM,
    };
}
